module.exports = __webpack_public_path__ + "static/media/(LH)_MG_5294_-_Pro-Natura_-_Moda_Feminina_-_Moda_Feminina_Infantil.67eb0a88.jpg";